(function ($) {
	$(document).on('click', '.js-datalayer-click', function () {
		var id = $(this).data('id');
		if (id > 0 && typeof dataLayer != 'undefined') {
			if (window.productsInfo[id]) {
				var obProduct = window.productsInfo[id];
				obProduct.position = 1;
				dataLayer.push({
					'ecommerce': {
						'click': {
							'actionField': {'list': obProduct.category,},
							'products': [
								obProduct
							],
						},
					},
					'event': 'productClick',
					'EE-event-category': 'ecommerce',
					'EE-event-action': 'productClick',
					'EE-event-non-interaction': 'True',
				});
			}
			if (window.promoInfo[id]) {
				var obPromo = window.promoInfo[id];
				dataLayer.push({
					'ecommerce': {
						'promoClick': {
							'promotions': [
								obPromo
							],
						},
					},
					'event': 'EE-event',
					'EE-event-category': 'Enhanced Ecommerce',
					'EE-event-action': 'promoClick',
					'EE-event-non-interaction': 'True',
				});
			}
		}
	});
})(jQuery);
